import cart from './config/CartConfig';
import joinmore from './config/JoinmoreConfig';
import cashier from './config/CashierConfig';
import RecConfig from './config/RecConfig';
import CheckoutConfig from './config/CheckoutConfig';
import VoucherConfig from './config/VoucherConfig';
import InvoiceConfig from './config/InvoiceConfig';
import InvoiceDetailConfig from './config/InvoiceDetailConfig';
import OrderInvoiceExchangeConfig from './config/OrderInvoiceExchangeConfig';
import OrderInvoiceDetailConfig from './config/OrderInvoiceDetailConfig';
import AddressConfig from './config/AddressConfig';
import EcardConfig from './config/EcardConfig';
import paySuccess from './config/paySuccessConfig';
import ProductConfig from './config/ProductConfig';
import RecycleConfig from './config/RecycleConfig';
import MatchConfig from './config/MatchConfig';
import StoreConfig from './config/StoreConfig';
import StoreAddressConfig from './config/StoreAddress';
import StoreSearchConfig from './config/StoreSearchConfig';
import product3dShowConfig from './config/Product3dShowConfig';
import ElectronicCardConfig from './config/ElectronicCardConfig';
import { ReciveGiftCardConf } from './config/ReciveGiftCard';
import SnapshotConfig from './config/SnapshotConfig';

const Config = {
  ...cart,
  ...joinmore,
  ...cashier,
  ...paySuccess,
  ...CheckoutConfig,
  ...VoucherConfig,
  ...InvoiceConfig,
  ...InvoiceDetailConfig,
  ...OrderInvoiceExchangeConfig,
  ...OrderInvoiceDetailConfig,
  ...AddressConfig,
  ...EcardConfig,
  ...ProductConfig,
  ...RecycleConfig,
  ...MatchConfig,
  ...StoreConfig,
  ...StoreAddressConfig,
  ...StoreSearchConfig,
  ...product3dShowConfig,
  ...ElectronicCardConfig,
  ...ReciveGiftCardConf,
  ...SnapshotConfig,
};

export default Config;
